

































import { Component, Vue } from "vue-property-decorator";
import { Cell, Checkbox, CheckboxGroup, Button } from "vant";
import CustomSelect from "../components/CustomSelect.vue";

@Component({
  components: {
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    customSelect: CustomSelect,
    [Button.name]: Button
  }
})
export default class Investment extends Vue {
  list = [
    {
      label: "股票",
      value: "",
      options: [
        {
          text: "没有经验",
          value: 1
        },
        {
          text: "少于一年",
          value: 2
        },
        {
          text: "一至三年",
          value: 3
        },
        {
          text: "三至五年",
          value: 4
        },
        {
          text: "五年以上",
          value: 5
        }
      ]
    },
    {
      label: "结构性产品",
      value: "",
      options: [
        {
          text: "没有经验",
          value: 1
        },
        {
          text: "少于一年",
          value: 2
        },
        {
          text: "一至三年",
          value: 3
        },
        {
          text: "三至五年",
          value: 4
        },
        {
          text: "五年以上",
          value: 5
        }
      ]
    },
    {
      label: "外汇/商品",
      value: "",
      options: [
        {
          text: "没有经验",
          value: 1
        },
        {
          text: "少于一年",
          value: 2
        },
        {
          text: "一至三年",
          value: 3
        },
        {
          text: "三至五年",
          value: 4
        },
        {
          text: "五年以上",
          value: 5
        }
      ]
    },
    {
      label: "认股权/股票期权",
      value: "",
      options: [
        {
          text: "没有经验",
          value: 1
        },
        {
          text: "少于一年",
          value: 2
        },
        {
          text: "一至三年",
          value: 3
        },
        {
          text: "三至五年",
          value: 4
        },
        {
          text: "五年以上",
          value: 5
        }
      ]
    },
    {
      label: "期货/期权",
      value: "",
      options: [
        {
          text: "没有经验",
          value: 1
        },
        {
          text: "少于一年",
          value: 2
        },
        {
          text: "一至三年",
          value: 3
        },
        {
          text: "三至五年",
          value: 4
        },
        {
          text: "五年以上",
          value: 5
        }
      ]
    },
    {
      label: "其他金融产品",
      value: "",
      options: [
        {
          text: "没有经验",
          value: 1
        },
        {
          text: "少于一年",
          value: 2
        },
        {
          text: "一至三年",
          value: 3
        },
        {
          text: "三至五年",
          value: 4
        },
        {
          text: "五年以上",
          value: 5
        }
      ]
    }
  ];

  get isNextDisabled() {
    return this.list.some(item => {
      if (typeof item.value == "string") {
        return item.value == "";
      } else if (
        Object.prototype.toString.call(item.value) == "[object Array]"
      ) {
        return (item.value as any).length === 0;
      }
    });
  }

  handleNextStep() {
    window.sessionStorage.setItem("investmentList", JSON.stringify(this.list));
    this.$router.push("/survey/derivative");
  }
}
